/**
 * Origin used for generated Auto Apply / Confirmation links on `/test/rbs`.
 * Empty/whitespace → `fallbackOrigin` (the current host when running on QA).
 * Otherwise parse as a URL so testers can paste a lemma host (with or without
 * protocol or path) instead of hand-editing the generated links.
 * Invalid values (e.g. malformed text, `javascript:`) fall back to
 * `fallbackOrigin` so they never land in generated hrefs.
 */
export function resolveLinkOrigin(baseUrl: string, fallbackOrigin: string): string {
    const normalizedFallback = fallbackOrigin.replace(/\/+$/, '');
    const trimmed = baseUrl.trim();
    if (!trimmed) {
        return normalizedFallback;
    }

    const withProtocol = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
    try {
        return new URL(withProtocol).origin;
    } catch {
        return normalizedFallback;
    }
}
